// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/tabletop-tracker/tabletop-tracker/apps/mobile/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/home/runner/work/tabletop-tracker/tabletop-tracker/apps/mobile/app/(tabs)/index.tsx"); } },
  "./(tabs)/plays.tsx": { enumerable: true, get() { return require("/home/runner/work/tabletop-tracker/tabletop-tracker/apps/mobile/app/(tabs)/plays.tsx"); } },
  "./(tabs)/shelf.tsx": { enumerable: true, get() { return require("/home/runner/work/tabletop-tracker/tabletop-tracker/apps/mobile/app/(tabs)/shelf.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/tabletop-tracker/tabletop-tracker/apps/mobile/app/_layout.tsx"); } },
  "./game/[slug].tsx": { enumerable: true, get() { return require("/home/runner/work/tabletop-tracker/tabletop-tracker/apps/mobile/app/game/[slug].tsx"); } },
  "./sign-in.tsx": { enumerable: true, get() { return require("/home/runner/work/tabletop-tracker/tabletop-tracker/apps/mobile/app/sign-in.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;